import { sanitizeText } from "./sanitize";

const hasUrlCoupon = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const couponCode = urlParams.get("cupom");
  const shouldUseCoupon =
    sanitizeText(couponCode) && sanitizeText(couponCode) !== "null"
      ? sanitizeText(couponCode)
      : false;

  return shouldUseCoupon;
};

export default hasUrlCoupon;
